import animations from '../../modules/animations'

export default class ContentList {
  constructor(section) {
    if (!section) return

    animations.content_list(section)
  }
}
